import React from 'react';
import { Meteor } from 'meteor/meteor';

import {
	Col,
	BPanel,
	FormControl,
	FormGroup,
	ControlLabel,
	Table,
	Button,
	Checkbox
} from '@sketchpixy/rubix';
import { PassengerComponent } from './component-passengers-list';


export class AddPassengersComponent extends React.Component {
	
	constructor(props) {
			super(props);
			this.state = {};
			this.state.tempID = props.tempID;
			this.onUpdate = props.onUpdate;
			this.calculBetterPrice = props.calculBetterPrice;
	}


	renderPassengers() {
		return this.props.passengers && this.props.passengers.map((passenger) => (
			<PassengerComponent passenger={passenger} flight={this.props.flight} calculBetterPrice={this.calculBetterPrice.bind(this)}/>
		));
	}

	render() {
		return (
			<Col sm={12}>
				<BPanel header="Ajouter un passager">
						<FormGroup controlId="formHorizontalEmail" ref="addPassenger">
						<Col sm={12}>
							<Table responsive>
								<thead>
									<tr>
										<th>NOM</th>
										<th>PRÉNOM</th>
										<th>AGE</th>
										<th>POIDS</th>
										<th>PORTABLE / TÉL</th>
										<th>EMAIL</th>
										<th>INFO</th>
										<th>M*</th>
										<th>&nbsp;</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td><FormControl type="text" ref="passenger_last_name"/></td>
										<td><FormControl type="text" ref="passenger_first_name"/></td>
										<td><FormControl type="text" ref="passenger_age"/></td>
										<td><FormControl type="text" ref="passenger_weight"/></td>
										<td><FormControl type="text" ref="passenger_phone"/></td>
										<td><FormControl type="text" ref="passenger_email"/></td>
										<td><FormControl type="text" ref="passenger_info"/></td>
										<td>
											<FormControl componentClass="select" type="select" ref="passenger_mobility">
													<option value={false}>Non</option>
													<option value={true}>Oui</option>
											</FormControl>
										</td>
										<td><Button bsStyle="success" onClick={this.onUpdate.bind(this)}>+ AJOUTER</Button></td>
									</tr>
								</tbody>
							</Table>
							<p>*M : Mobilité réduite.</p>
						</Col>
					</FormGroup>
				</BPanel>

				<BPanel header="Liste des passagers">
						<FormGroup controlId="formHorizontalEmail">
						<Col sm={12}>
							<Table responsive>
								<thead>
									<tr>
										<th>NOM</th>
										<th>PRÉNOM</th>
										<th>AGE</th>
										<th>POIDS</th>
										<th>PORTABLE / TÉL</th>
										<th>Email</th>
										<th>INFO</th>
										<th>Montant</th>
										<th>M*</th>
										<th>&nbsp;</th>
									</tr>
								</thead>
								<tbody>
									{this.renderPassengers()}
								</tbody>
							</Table>
							<p>*M : Mobilité réduite.</p>
							<center><Button bsStyle="primary">{this.props.passengers && this.props.passengers.length} / {this.props.maxPassengers} passagers</Button></center>
						</Col>
					</FormGroup>
				</BPanel>
			</Col>
		);
	}

}



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/component-add-passengers.js
 **/